import { Component, h, Prop } from '@stencil/core';

import { SectionStore } from '../../../../utils/Stores/section-store';

@Component({
  tag: 'event-switch-module',
  styleUrl: 'event-switch-module.scss',
  shadow: true,
})
export class ModuleEventSwitch {
  @Prop() readonly reload: boolean;

  render() {
    // ERROR : 401 unauthorized
    if (SectionStore?.get('section')?.error_unauthorized) {
      return (
        <chat-message-error-unauthorized-component></chat-message-error-unauthorized-component>
      );
    }

    // ALERT : CONTINUE
    else if (SectionStore?.get('section')?.alert_continue) {
      return <bot-event-continue-component></bot-event-continue-component>;
    }

    // ERROR : DEFAULT
    else if (SectionStore?.get('section')?.error_default) {
      return <chat-message-error-default-component></chat-message-error-default-component>;
    }
  }
}
